import { Formik } from 'formik'
import React, { useCallback, useMemo } from 'react'

import { mapZodToFormikErrors } from '@src/utils/mapZodToFormikErrors'

import { TableFulfilmentForm } from './TableFulfilmentForm'
import { useTableFulfilmentFormikProps } from './useTableFulfilmentFormikProps/useTableFulfilmentFormikProps'

// Component which renders the loading state while the formik props and addresses
// are loaded
export const TableFulfilmentStep: React.FC = () => {
  const formikProps = useTableFulfilmentFormikProps()
  const validate = useCallback(
    async values => {
      const parsed = await formikProps.zodValidationSchema.safeParseAsync(
        values
      )
      if (!parsed.success) {
        return mapZodToFormikErrors(parsed.error)
      }
    },
    [formikProps.zodValidationSchema]
  )

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const memoizedInitialValues = useMemo(() => formikProps.initialValues, [])

  return (
    <Formik
      enableReinitialize={false}
      initialValues={memoizedInitialValues}
      onSubmit={formikProps.handleSubmit}
      validate={validate}
      component={TableFulfilmentForm}
    />
  )
}
